export default __webpack_public_path__ + "static/media/footer-blue-bg.bad4f86f.fe0440eb.svg";